import { createContext, useContext, useRef, useState } from "react";
import orderAPI from "../api/orderApi";

const NotificationContext = createContext();

export const useNotification = () => useContext(NotificationContext);

export const NotificationProvider = ({ children }) => {
  const [orders, setOrders] = useState([]);
  const [unread, setUnread] = useState(false);

  const prevOrderIdsRef = useRef(new Set());

  const fetchOrders = async () => {
    try {
      const res = await orderAPI.getLastOrder();

      if (res.code === 200) {
        const incoming = res.data;

        // check new orders
        const newOnes = incoming.filter(
          (o) => !prevOrderIdsRef.current.has(o._id),
        );

        if (newOnes.length > 0) {
          setUnread(true);
          playBeep();
        }

        prevOrderIdsRef.current = new Set(incoming.map((o) => o._id));
        setOrders(incoming);
      }
    } catch (err) {
      console.error("Notification fetch error:", err);
    }
  };

  // 🔊 beep
  const playBeep = () => {
    try {
      const ctx = new (window.AudioContext || window.webkitAudioContext)();
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();

      osc.connect(gain);
      gain.connect(ctx.destination);

      osc.frequency.value = 800;
      gain.gain.setValueAtTime(0.3, ctx.currentTime);

      osc.start();
      osc.stop(ctx.currentTime + 0.3);
    } catch (_) {}
  };

  return (
    <NotificationContext.Provider
      value={{
        orders,
        unread,
        setUnread,
        fetchOrders, // optional manual refresh
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};
